import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

interface CategoryState {
  activeCategories: string[];
}

const initialState: CategoryState = {
  activeCategories: ['all'],
};

export const categorySlice = createSlice({
  name: 'category',
  initialState,
  reducers: {
    setActiveCategories: (state, action: PayloadAction<string[]>) => {
      state.activeCategories = action.payload;
    },
    toggleCategory: (state, action: PayloadAction<string>) => {
      const category = action.payload;
      if (category === 'all') {
        state.activeCategories = ['all'];
      } else {
        const isActive = state.activeCategories.includes(category);
        const newCategories = isActive
          ? state.activeCategories.filter((c) => c !== category)
          : [...state.activeCategories.filter((c) => c !== 'all'), category];
        state.activeCategories = newCategories.length ? newCategories : ['all'];
      }
    },
  },
});

export const { setActiveCategories, toggleCategory } = categorySlice.actions;

export default categorySlice.reducer;
